<template>
    <b-list-group-item :disabled="isDisabled" @click="goToNext()">
        <!-- <div class="list-title">
            <b-row>
                <b-col cols="10">
                    {{ model.part!=null ? model.part.partNumber:'' }}
                </b-col>
            </b-row>
        </div>
        <div>{{ model.purchaseOrder != null ? model.purchaseOrder.name : '-' }}</div>
        <div>{{ model.materialIssueDate }}</div> -->
        <b-row>
                <b-col cols="12" class="list-title">
                    {{ model.part.partNumber }}
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    {{ model.part.partName }}
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    {{ model.remainingQty}}
                </b-col>
            </b-row>
    </b-list-group-item>
</template>
<script>
export default {
    props: {
        model: {
            default: {},
            type: Object
        },
        isDisabled: {
            default: Boolean,
            type: false
        }
    },
    methods: {
        goToNext() {
            if(!this.isDisabled) {
                this.$emit('nextAction');
            }
        }
    },
    computed: {
        getStatusStyle() {
            return {
                color: this.model.isScanned == null || this.model.isScanned == false ? 'red' : 'green',
                // Add more styles as needed
            };
        },
    },
}
</script>
<style>
    .scanStatus {
        display: flex;
        font-size: 14px !important;
        align-items: center;
        justify-content: flex-end;
    }
</style>